import SubmissionInstructionModalModule from './submission-instruction-modal.module'

export default SubmissionInstructionModalModule
